import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'
import {CSRRateModel} from '../Model'

function* getCSRRateSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getCsrRate, params)
    yield put(actions.getCsrRateSuccess(response?.data?.data))
    yield put(actions.getCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getCsrRateFinish())
  }
}

function* addCsrRateSaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addCsrRate, body)
    yield put(actions.addCsrRateSuccess(response.data?.data))
    yield delay(100)
    yield put(actions.addCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addCsrRateFinish())
  }
}

function* enableCsrRateSaga(action: ActionModel) {
  try {
    const selectedCsrRate: any = action.payload?.data
    const response: ResponseModel = yield call(service.enableCsrRate, selectedCsrRate)
    yield put(actions.enableCsrRateSuccess(response?.data))
    yield delay(100)
    yield put(actions.enableCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.enableCsrRateFinish())
  }
}

function* disableCsrRateSaga(action: ActionModel) {
  try {
    const selectedCsrRate: any = action.payload?.data
    const response: ResponseModel = yield call(service.disableCsrRate, selectedCsrRate)
    yield put(actions.disableCsrRateSuccess(response?.data))
    yield delay(100)
    yield put(actions.disableCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.disableCsrRateFinish())
  }
}

function* singleEnableCsrRateSaga(action: ActionModel) {
  try {
    const selectedCsrRate: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleEnableCsrRate, selectedCsrRate)
    yield put(actions.singleEnableCsrRateSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleEnableCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleEnableCsrRateFinish())
  }
}

function* singleDisableCsrRateSaga(action: ActionModel) {
  try {
    const selectedCsrRate: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleDisableCsrRate, selectedCsrRate)
    yield put(actions.singleDisableCsrRateSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleDisableCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleDisableCsrRateFinish())
  }
}

/* function* updateCsrRateSaga(action: ActionModel) {
  try {
    const body: CsrRateModel = action.payload
    const response: ResponseModel = yield call(service.updateCsrRate, body, action.payload?.id)
    yield put(actions.updateCsrRateSuccess(response.data?.data))
    yield put(actions.updateCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateCsrRateFinish())
  }
} */
function* updateCsrRateSaga(action: ActionModel) {
  try {
    const body: CSRRateModel = action.payload
    const params: any = action
    const response: ResponseModel = yield call(service.updateCsrRate, body, params.id)

    yield put(actions.updateCsrRateSuccess(response.data?.data))
    yield put(actions.updateCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateCsrRateFinish())
  }
}

function* deleteCsrRateSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteCsrRate, body)

    yield put(actions.deleteCsrRateSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteCsrRateFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteCsrRateFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_CSR_RATE_START, getCSRRateSaga)
  yield takeLatest(actionTypes.ADD_CSR_RATE_START, addCsrRateSaga)
  yield takeLatest(actionTypes.UPDATE_CSR_RATE_START, updateCsrRateSaga)
  yield takeLatest(actionTypes.DELETE_CSR_RATE_START, deleteCsrRateSaga)
  yield takeLatest(actionTypes.ENABLE_CSR_RATE_REQUEST, enableCsrRateSaga)
  yield takeLatest(actionTypes.DISABLE_CSR_RATE_REQUEST, disableCsrRateSaga)
  yield takeLatest(actionTypes.SINGLE_ENABLE_CSR_RATE_REQUEST, singleEnableCsrRateSaga)
  yield takeLatest(actionTypes.SINGLE_DISABLE_CSR_RATE_REQUEST, singleDisableCsrRateSaga)
}
